import { connect } from 'react-redux';
import {
  makeSortedAssignmentsArraySelector,
  selectAvailabilityById,
} from '../../../reducers/entities/postings/selectors';
import TimelineAvailability from '../../../components/DailyPlanning/TimelineAvailability/TimelineAvailability';

// Used for memoization
const makeMapStateToProps = () => {
  const selectSortedAssignmentsArrayByAvaliabilityId = makeSortedAssignmentsArraySelector();
  const mapStateToProps = (state, props) => ({
    sortedAssignments: selectSortedAssignmentsArrayByAvaliabilityId(state, props),
    availability: selectAvailabilityById(state, props),
  });
  return mapStateToProps;
};

const TimelineAssignmentContainer = connect(
  makeMapStateToProps(),
  null,
)(TimelineAvailability);

export default TimelineAssignmentContainer;
